<template>
  <div class="head _row">
    <div
      v-for="(item, index) in routeList"
      :key="index"
      :class="[
        item.route == $route.path
          ? 'head_child_click'
          : item.hover
          ? 'head_child_hover'
          : 'head_child',
        'head_common',
      ]"
      @click.stop="mouseDown(item)"
      @mouseenter="mouseEnter(item)"
      @mouseleave="mouseLeave(item)"
    >
      <!-- <i v-if="item.icon" :class="item.icon"></i> -->
      <p>{{ $t(item.title) }}</p>
      <i
        v-if="item.route != '/deviceList'"
        :class="[
          'el-icon-close',
          '_col_center',
          item.route == showCloseRoute ? 'icon_down' : '_icon',
        ]"
        @mouseenter="iconEnter(item)"
        @mouseleave="iconLeave"
        @click.stop="closeRoute(item, index)"
      ></i>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      headClass: "head_child_hover",
      showCloseRoute: null,
      curPath: null,
      routeList: [
        {
          title: "lang.设备列表",
          name: "DeviceList",
          route: "/deviceList",
          hover: false,
        },
      ],
    };
  },
  created() {
    this.addKeepAlive("HouseList");
  },
  mounted() {
    let that = this;
    this.$bus.$on("navClose", function (data) {
      for (let i = 0; i < that.routeList.length; i++) {
        if (that.routeList[i].route === data) {
          that.closeRoute(that.routeList[i], i);
          return;
        }
      }
    });
  },
  watch: {
    $route(to, from) {
      console.log("to", to);
      this.curPath = to.path;
      let list = this.routeList.filter((item) => item.route == to.path);
      if (list.length == 0) {
        this.routeList.push({
          title: to.meta.title,
          route: to.path,
          name: to.name,
          hover: false,
        });
        this.addKeepAlive(to.name);
      }
    },
  },
  methods: {
    ...mapActions({
      addKeepAlive: "addKeepAlivePage",
      delKeepAlive: "delKeepAlivePage",
    }),
    mouseDown(e) {
      if (e.route == this.$route.path) {
        return;
      }
      this.$router.push(e.route);
    },
    mouseEnter(e) {
      if (e.route == this.$route.path) {
        return;
      }
      this.routeList.forEach((item) => {
        item.hover = item.route == e.route;
      });
    },
    mouseLeave(e) {
      e.hover = false;
    },
    iconEnter(e) {
      this.showCloseRoute = e.route;
    },
    iconLeave(e) {
      this.showCloseRoute = null;
    },
    closeRoute(e, i) {
      this.showCloseRoute = null;
      this.routeList.splice(i, 1);
      this.delKeepAlive(e.name);
      if (this.curPath == e.route) {
        this.$route.meta.keepAlive = false;
        this.$router.replace(this.routeList[i - 1].route);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  height: 45px;
  background-color: #fff;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  overflow: hidden;
}
.head_common {
  border-radius: 3px;
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  cursor: pointer;
  height: 30px;
  white-space: nowrap;
}
.head_child {
  border: 1px solid #bfbfbf;
  ._icon {
    color: #999999;
    margin-left: 8px;
    font-size: 10px;
    padding: 2px;
  }
  p {
    font-size: 14px;
    color: #666;
  }
}
.head_child_click {
  border: 1px solid #409eff;
  ._icon {
    color: #409eff;
    margin-left: 8px;
    font-size: 10px;
    padding: 2px;
  }
  p {
    font-size: 14px;
    color: #409eff;
  }
}
.head_child_hover {
  border: 1px solid #c6e2ff;
  background-color: #ecf5ff;
  ._icon {
    color: #409eff;
    margin-left: 8px;
    font-size: 10px;
    padding: 2px;
  }
  p {
    font-size: 14px;
    color: #409eff;
  }
}
.icon_down {
  color: #409eff;
  border-radius: 16px;
  background-color: rgba(207, 207, 207, 0.644);
  font-size: 10px;
  margin-left: 8px;
  padding: 2px;
}
</style>
